import {AuthService, UserType} from '@app/core/services/auth.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {LocalStorageService} from '@app/core/services/local-storage.service';

export function AppInitializer(authService: AuthService, localStorageService: LocalStorageService, interService: InternationalizationService, store: Store<IAppState>): () => Promise<any> {
	const disableRedirectRoutes = ['/new-user', '/forgot-password', '/debug', '/reset-password', '/register', '/verify-email'];
	const lang = navigator.language.slice(0, 2); // chrome returns "da" | safari returns "da-DK"
	interService.setLang(interService.navigatorLangToLanguage[lang]);

	return (): Promise<any> =>
		new Promise((resolve) => {
			// Set a timeout for the users details to arrive. If it exceeds then redirect to login
			const timeout = setTimeout(() => {
				if (disableRedirectRoutes.indexOf(window.location.pathname) === -1) {
					authService.router.navigate(['./login']);
				}
				resolve(true);
				clearTimeout(timeout);
			}, 3000);
			switch (authService.userType) {
				case UserType.USER: {
					loginUserTypeUser(authService, resolve, timeout, disableRedirectRoutes);
					break;
				}
				case UserType.PUNCH_USER: {
					loginUserTypePunchUser(authService, localStorageService, store, resolve, timeout, disableRedirectRoutes);
					break;
				}
				default: {
					if (disableRedirectRoutes.indexOf(window.location.pathname) === -1) {
						authService.router.navigate(['./login']);
					}
					resolve(true);
					clearTimeout(timeout);
				}
			}
		});
}

export function loginUserTypePunchUser(authService: AuthService, localStorageService: LocalStorageService, store: Store<IAppState>, resolve, timeout, disableRedirectRoutes): void {
	const tenantId = localStorageService.getAuthTenantId();
	const departmentId = localStorageService.getAuthDepartmentId();
	authService.runDetailsCheckPunchUser(tenantId, departmentId).then(() => {
		authService.router.navigate(['./punch-clock']);
	}, () => {
		if (disableRedirectRoutes.indexOf(window.location.pathname) === -1) {
			authService.router.navigate(['./punch-login']);
		}
	}).finally(() => {
		resolve(true);
		clearTimeout(timeout);
	});
}

export function loginUserTypeUser(authService: AuthService, resolve, timeout, disableRedirectRoutes): void {
	// login and redirect as user
	// Try to get current user details
	authService.runDetailsCheck().then(() => {
		// Successful login
		if (['/locked', '/login', '/', '/punch-clock', '/punch-login', '/verify-email'].indexOf(window.location.pathname) !== -1) {
			if (authService.currentUser.isAdmin()) {
				(authService.tenant.getting_started)
					? authService.router.navigate(['./home/kom-i-gang'])
					: authService.router.navigate(['./home/oversigt']);
			} else {
				authService.router.navigate(['./home/oversigt']);
			}
		}
		resolve(true);
		clearTimeout(timeout);
	}, () => {
		// Not logged in: Redirect to login page
		if (disableRedirectRoutes.indexOf(window.location.pathname) === -1) {
			authService.router.navigate(['./login']);
		}
		resolve(true);
		clearTimeout(timeout);
	});
}
